var _g;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgPublishTemplate(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "92px",
    height: "91px",
    viewBox: "0 0 92 91",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Group",
    transform: "translate(0.5 0.5)"
  }, /*#__PURE__*/React.createElement("path", {
    className: "fill-primary-color",
    d: "M54.15 0C55.6116 0 56.8162 1.09378 56.9808 2.50291L57 2.83333L57 65.1667C57 66.6197 55.8998 67.8173 54.4824 67.9809L54.15 68L31.35 68C29.776 68 28.5 66.7315 28.5 65.1667C28.5 63.7136 29.6002 62.5161 31.0176 62.3524L31.35 62.3333L51.3 62.3333L51.3 5.66667L25.7048 5.66614L5.7 6.04633L5.7 36.8333C5.7 38.2864 4.59979 39.4839 3.18237 39.6476L2.85 39.6667C1.38842 39.6667 0.183805 38.5729 0.019174 37.1638L0 36.8333L0 3.26923C0 1.83591 1.07163 0.647486 2.46763 0.461261L2.7952 0.436421L25.65 0L54.15 0Z",
    transform: "matrix(-1 0 0 1 74 11)",
    id: "Path-2",
    fill: "#07A5DF",
    stroke: "none"
  }), /*#__PURE__*/React.createElement("path", {
    className: "fill-primary-color",
    d: "M26.0421 0.970072C27.055 -0.194719 28.8341 -0.329612 30.0158 0.66878C31.1066 1.59037 31.3072 3.15546 30.5349 4.30693L30.3215 4.58557L13.4124 24.03C12.4204 25.1707 10.7084 25.3144 9.53949 24.413L9.27996 24.1864L0.825425 15.8531C-0.275142 14.7683 -0.275142 13.0095 0.825425 11.9247C1.84133 10.9234 3.43989 10.8464 4.54544 11.6936L4.81093 11.9247L11.1121 18.1333L26.0421 0.970072Z",
    transform: "translate(48 56)",
    id: "Path-8",
    fill: "#0B67B2",
    stroke: "none"
  }), /*#__PURE__*/React.createElement("path", {
    className: "fill-secondary-color",
    d: "M14.1667 0L2.83333 0C1.26853 0 0 1.26853 0 2.83333L0 14.1667C0 15.7315 1.26853 17 2.83333 17L14.1667 17C15.7315 17 17 15.7315 17 14.1667L17 2.83333C17 1.26853 15.7315 0 14.1667 0ZM11.3333 5.66667L11.3333 11.3333L5.66667 11.3333L5.66667 5.66667L11.3333 5.66667Z",
    transform: "translate(28 25)",
    id: "Rectangle",
    fill: "#07A5DF",
    stroke: "none"
  }), /*#__PURE__*/React.createElement("path", {
    className: "fill-secondary-color",
    d: "M14.1667 0L2.83333 0C1.26853 0 0 1.26853 0 2.83333L0 14.1667C0 15.7315 1.26853 17 2.83333 17L14.1667 17C15.7315 17 17 15.7315 17 14.1667L17 2.83333C17 1.26853 15.7315 0 14.1667 0ZM11.3333 5.66667L11.3333 11.3333L5.66667 11.3333L5.66667 5.66667L11.3333 5.66667Z",
    transform: "translate(28 45)",
    id: "Rectangle-Copy",
    fill: "#07A5DF",
    stroke: "none"
  }), /*#__PURE__*/React.createElement("path", {
    className: "fill-secondary-color",
    d: "M11.2 0C12.7464 0 14 1.34315 14 3C14 4.53851 12.9191 5.80652 11.5265 5.97982L11.2 6L2.8 6C1.2536 6 0 4.65685 0 3C0 1.46149 1.08091 0.193479 2.47346 0.0201832L2.8 0L11.2 0Z",
    transform: "translate(48 50)",
    id: "Path-4-Copy",
    fill: "#07A5DF",
    stroke: "none"
  }), /*#__PURE__*/React.createElement("path", {
    className: "fill-secondary-color",
    d: "M11.2 0C12.7464 0 14 1.34315 14 3C14 4.53851 12.9191 5.80652 11.5265 5.97982L11.2 6L2.8 6C1.2536 6 0 4.65685 0 3C0 1.46149 1.08091 0.193479 2.47346 0.0201832L2.8 0L11.2 0Z",
    transform: "translate(48 31)",
    id: "Path-4-Copy-2",
    fill: "#07A5DF",
    stroke: "none"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M0 0L91 0L91 90L0 90L0 0Z",
    id: "Rectangle",
    fill: "none",
    fillRule: "evenodd",
    stroke: "none"
  }))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgPublishTemplate);
export default __webpack_public_path__ + "static/media/publishTemplate.5c4ad93086f680a9dbc08d31d088ac43.svg";
export { ForwardRef as ReactComponent };